import React from "react";

import {AuthorizedEmployeesTableApp} from "../Funtionality/AuthorizedEmployeesTableApp";
import CustomTable from "../../../../components/table/CustomTable";
import {permissionObj} from "../../../../Helpers/permission";
import Subtitle from "../../../../components/Header/Subtitle";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import {AddIcon, TrashOutlineIcon} from "../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import DeleteModal from "../../../Modals/DeleteModal";
import ManageAuthorizedEmployeeModal from "../Modal/ManageAuthorizedEmployeeModal";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 */

const AuthorizedEmployeesTable = (props) => {
    const {
        id,
        DEV,
        permission,
        tableId,
        thead,
        tbody,
        pagination,
        show,
        setShow,
        modified,
        setModified,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        showDeleteModal,
        setShowDeleteModal,
        handleDeleteAll,
        handleCheckboxChange,
        handleManageEmployees,
        handleDeleteEmployee
    } = AuthorizedEmployeesTableApp(props);

    return (
        <div className={"mt-4"}>
            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_MANAGE_USERS)) && (
                <Subtitle name={'authorized_employees'} divStack={
                    <>
                        <ButtonSubAction
                            id='btn_szd_manage_employees'
                            name='manage_employees'
                            Icon={AddIcon}
                            onClick={handleManageEmployees}
                        />
                    </>
                }>
            {(DEV || permission?.includes(permissionObj?.WEB_ZONE_DELETE)) && (
                    <ButtonAction
                        id='btn_sed_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => setShowDeleteModal(true)}
                        splitName={false}
                    />
            )}
                </Subtitle>
            )}

            <CustomTable
                tableId={tableId}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                textNotInformation={"no_information"}
                handleCheckboxChange={handleCheckboxChange}
                onChangeCheckbox={handleDeleteAll}
                withoutHeight={true}
                isAllChecked={isAllChecked}
                selectedList={selectedList}
                checkbox={DEV || permission?.includes(permissionObj?.WEB_ZONE_MANAGE_USERS)}
            />
            {pagination()}

            {show &&
                <ManageAuthorizedEmployeeModal
                    show={show}
                    onHide={() => setShow(false)}
                    selectedId={id}
                    setModified={setModified}
                    modified={modified}
                />
            }

            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onClickFn={() => handleDeleteEmployee()}
                data={selectedList}
                title_modal={'remove_employees'}
                isReset={setSelectedList}
                element_modal={'authorized_employees'}
                description={'are_you_sure_you_want_to_remove'}
                isAllReset={setIsAllChecked}
            />
        </div>
    );
};

export default AuthorizedEmployeesTable;
